import { Environment } from './environment.interface';

export const environment: Environment = {
  name: 'prod',
  appClientId: '43mnt7o1jgb65nsi76vdq0buv0',
  region: 'us-west-2',
  identityPoolId: 'us-west-2:70e7b66a-7921-4374-8fa8-4009adfe064c',
  userPoolId: 'us-west-2_kvVYz3hke',
  domain: 'drift-prod-env.auth.us-west-2.amazoncognito.com',
  driftApi: 'https://l8115u7kje.execute-api.us-west-2.amazonaws.com',
  redirectSignIn: 'https://drift.slalom.com/home',
  redirectSignOut: 'https://drift.slalom.com/home',
  features: {
    enablePersonasManagement: true,
    enableSystemPrompts: true,
    enableReviewers: true,
    enableNewAdvisor: true,
    enableOldAdvisor: false,
    enableSampleStyles: false,
    enableLibrary: false
  },
  enableMocks: false
};
